import { render, staticRenderFns } from "./shareDataJd.vue?vue&type=template&id=31b218f3&scoped=true&"
import script from "./shareDataJd.vue?vue&type=script&lang=js&"
export * from "./shareDataJd.vue?vue&type=script&lang=js&"
import style0 from "./shareDataJd.vue?vue&type=style&index=0&id=31b218f3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b218f3",
  null
  
)

export default component.exports